export default __webpack_public_path__ + "static/media/login.dda684cb.svg";